import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactHighcharts from "react-highcharts";
import totalESModel from "models/TotalES";

class TotalES extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data;
  }
  render() {
    return (
      <Fragment>
        <ReactHighcharts config={totalESModel(this.props.data)} />
      </Fragment>
    );
  }
}

TotalES.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default TotalES;



// WEBPACK FOOTER //
// ./src/components/ReportDetail/TotalES.jsx